import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import NavBar from './Component/Header/NavBar';
import Home from './Component/Home/Home';
import MeetNeo from './Component/MeetNeo/MeetNeo';
import Footer from './Component/Footer/Footer';
import Pricing from './Component/Pricing/Pricing';
import Blogs from './Component/Blogs/Blogs';
import ContactUs from './Component/ContactUs/ContactUs';
import Register from './Component/Register/Register';
import SignIn from './Component/Register/SignIn/SignIn';
import Login from './Component/Login/Login';

import './App.css';

function App() {

  const location = useLocation();
  // console.log(location)
  const pathsWithoutFooter = ['/register', '/signin'];
  const shouldRenderFooter = !pathsWithoutFooter.includes(location.pathname);

  return (
    <>
      <NavBar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/meetneo' element={<MeetNeo />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/blogs' element={<Blogs />} />
        <Route path='/contact' element={<ContactUs />} />
        <Route path='/register' element={<Register />} />
        <Route path='/signin' element={<SignIn />} />
        {/* <Route path='/login' element={<Login />} /> */}
        <Route path='*' element={<div>404! Page Not Found</div>} />
      </Routes>

      {shouldRenderFooter && <Footer />} {/* Conditionally render the footer */}

    </>
  );
}



// function App() {

//   const location = useLocation();
//   // Define an array of paths where you want to exclude the footer
//   const pathsWithoutFooter = ['/register', '/signin'];
//   const shouldRenderFooter = !pathsWithoutFooter.includes(location.pathname);


//   return (
//     <Router>

//       <NavBar />

//       <Routes>

//         <Route path='/' element={<Home />} />
//         <Route path='/meetneo' element={<MeetNeo />} />
//         <Route path='/pricing' element={<Pricing />} />
//         <Route path='/blogs' element={<Blogs />} />
//         <Route path='/contact' element={<ContactUs />} />

//         <Route path='/register' element={<Register />} />
//         <Route path='/signin' element={<SignIn />} />

//         {/* Es ko style krna h ache se */}
//         <Route path='*' element={<div>404! Page Not Found </div>} />

//       </Routes>

//       {shouldRenderFooter && <Footer />} {/* Conditionally render the footer */}

//       {/* <Footer /> */}

//     </Router>
//   );
// }

export default App;
